import { appConfigContext } from 'nexchange-service/appServiceConfig'

import { FIAT_COINS } from './FIAT_COINS'

const getIsPairCustomExcluded = (quote, base) => {
    const { CUSTOM_EXCLUDED_COINS } = appConfigContext.getAppConfig()
    return CUSTOM_EXCLUDED_COINS.includes(quote) || CUSTOM_EXCLUDED_COINS.includes(base)
}

const getIsCoinCustomExcluded = coinCode =>
    appConfigContext.getAppConfig().CUSTOM_EXCLUDED_COINS.includes(coinCode)

const isFiatCurrency = currencyCode => FIAT_COINS.includes(currencyCode)

export { getIsPairCustomExcluded, getIsCoinCustomExcluded, isFiatCurrency }
